export const HomeIcon = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.968811" width="24.1283" height="23.2204" fill="white" />
    <path
      d="M12.0642 3.87134L1.00537 11.3351H3.77007V21.2867H9.29948V16.3109H14.8289V21.2867H20.3583V11.2604L23.123 11.3351L12.0642 3.87134Z"
      fill="#8090A9"
    />
  </svg>
);
